import { Box, TextField, TextFieldProps, useTheme } from "@mui/material";
import React from "react";

export const CompactTextField = React.forwardRef(function (
  props: TextFieldProps,
  ref: any
) {
  const theme = useTheme();
  const { helperText, ...restProps } = props;

  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
        cursor: "text !important",
        userSelect: "none",
        boxShadow: `0px 0px 1px ${theme.palette.grey[300]}`,
      }}
    >
      <Box className="input-wrapper">
        <TextField
          ref={ref}
          size="small"
          fullWidth
          helperText={helperText || " "}
          sx={{
            "& .MuiInputBase-input": {
              px: 1.5,
              py: 2.5,
              pb: 0,
              color: theme.palette.text.primary,
              fontWeight: 500,
            },
            "& fieldset": { border: "none" },
            "& .MuiFormLabel-root": {
              transform: `translate(12px, 16px) scale(1)`,
              color: `${theme.palette.grey[600]} !important`,
            },
            "& .MuiFormLabel-root.MuiInputLabel-shrink": {
              transform: `translate(12px, 2px) scale(0.75)`,
              color: `${theme.palette.primary.main} !important`,
              fontWeight: 600,
            },
            "& .MuiFormHelperText-root": {
              lineHeight: 1,
              margin: 0,
              pb: "2px",
              pl: 1.5,
              opacity: !!props?.error ? 1 : 0,
              transition: `opacity 0.15s ease-in-out`,
            },
            "& .MuiFormHelperText-root.Mui-error": {
              color: theme.palette.warning.main,
            },
            ...restProps.sx,
          }}
          {...restProps}
        />
      </Box>
    </Box>
  );
});

CompactTextField.displayName = "CompactTextField";
